import { Component, OnInit } from '@angular/core';
import { FooterService } from './footer.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

    public data: any;
    public currentYear: number = new Date().getFullYear();

    constructor(
		private content: FooterService
    ) {
        // this.content.getData().subscribe((data: any) => {
        //     this.data = data.data;
        // });
    }

    ngOnInit(): void {}

}